import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bsbadge',
	templateUrl:'./BSBadgePluginCompPage.html',
	styles: [],
	styleUrls:['./BSBadgePluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSBadgePluginCompPage
{
	mdContent_775 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.badge.BSBadge;
\`\`\``;
	mdContent_776 = `\`\`\`java
BSBadge(boolean asPill, BSBadgeOptions... options)
\`\`\``;
	mdContent_777 = `\`\`\`java
BSBadge(String text, boolean asPill, BSBadgeOptions... options)
\`\`\``;
	mdContent_778 = `\`\`\`java
BSBadge&lt;?&gt; badge = new BSBadge&lt;&gt;("Alert", true, BSBadgeOptions.Danger);
\`\`\``;
}
